// ruleNormalize.js
export const normalizeKeyValue = (obj = {}) =>
  Object.entries(obj).map(([key, value]) => ({ key, value }));

export const normalizeRule = (rule) => {
  if (!rule || typeof rule !== "object") return rule;

  const r = { ...rule };

  if (r.TYPE === "REST") {
    r.URL_PARAMS = normalizeKeyValue(r.URL_PARAMS);
    r.HEADERS = normalizeKeyValue(r.HEADERS);
    r.BODY = normalizeKeyValue(r.BODY);
  }

  if (r.TYPE === "RULE") {
    r.TRUE_STEP = (r.TRUE_STEP || []).map(normalizeRule);
    r.FALSE_STEP = (r.FALSE_STEP || []).map(normalizeRule);
  }

  if (r.TYPE === "ITERATION") {
    r.RULES = (r.RULES || []).map(normalizeRule);
  }

  return r;
};
